import Vue from "vue";
import Vuex from "vuex";
import { Ability } from "@casl/ability";
import abilityPlugin from "./ability";
import auth from "@/components/Auth/store";
import profile from "@/components/Profile/store";
import clients from "@/components/Clients/store";
import users from "@/components/Users/store";
import user from "@/components/User/store";
import client from "@/components/Client/store";
import cameras from "@/components/Cameras/store";
import servers from "@/components/Servers/store";
import server from "@/components/Server/store";
import timeline from "@/components/Timeline/store";
import intercoms from "@/components/Intercoms/store";
import intercom from "@/components/Intercom/store"
import org from "@/components/Org/store";
import orgs from "@/components/Orgs/store";
import sip_servers from "@/components/SipServers/store";
import sip_server from "@/components/SipServer/store";
import sideTaskTypes from "@/core/components/SelectCameraSidetask/store";
import priorities from "@/components/Priorities/store";


Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  plugins: [abilityPlugin],
  getters: {
    ability() {
      return new Ability([], {
        subjectaltname(subject) {
          return !subject || typeof subject === "string" ? subject : subject["resourceType"];
        },
      });
    },
  },
  modules: {
    auth,
    profile,
    clients,
    users,
    client,
    user,
    cameras,
    servers,
    server,
    timeline,
    intercoms,
    intercom,
    org,
    orgs,
    sip_servers,
    sip_server,
    sideTaskTypes,
    priorities,
  },
});
